import { ErrorAlert } from '@petseo/shared';
import type { ServiceVendorServiceDto } from '@/services/api/petseo.client.wrapper';

interface ServiceCheckboxListProps {
  services: ServiceVendorServiceDto[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  error?: string;
}

export function ServiceCheckboxList({ services, selectedIds, onChange, error }: ServiceCheckboxListProps) {
  return (
    <div className="mb-3">
      <label className="form-label fw-bold">Usługi</label>
      {error && <ErrorAlert errorMessage={error} />}
      <div className="d-flex flex-column gap-2">
        {services.map((service) => {
          const serviceIdStr = String(service.id);
          const isChecked = selectedIds.includes(serviceIdStr);
          return (
            <label key={serviceIdStr} className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isChecked}
                onChange={() => {
                  const newIds = isChecked ? selectedIds.filter((id) => id !== serviceIdStr) : [...selectedIds, serviceIdStr];
                  onChange(newIds);
                }}
              />
              <span className="form-check-label">
                {service.name} ({service.durationMinutes} min)
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
